import { Globe2, Menu, X } from "lucide-react";
import { ReactNode, useEffect, useState } from "react";
import { navItems } from "@/data/site";
import { useI18n } from "@/i18n/I18nProvider";
import { Link, useRouter } from "@/router";

export function Layout({ children }: { children: ReactNode }) {
  const { t, locale, toggleLocale } = useI18n();
  const { path } = useRouter();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [path]);

  return (
    <div className="site-shell">
      <header className="site-header">
        <Link className="brand-lockup" href="/" aria-label="Verdantfall home">
          <span className="brand-mark" aria-hidden="true">
            VF
          </span>
          <span>
            <strong>{t("brand.title")}</strong>
            <small>{t("brand.subtitle")}</small>
          </span>
        </Link>

        <button
          className="icon-button mobile-menu-toggle"
          type="button"
          aria-label={menuOpen ? t("nav.close") : t("nav.open")}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>

        <nav className={`site-nav ${menuOpen ? "is-open" : ""}`} aria-label="Primary navigation">
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className={path === item.href ? "is-active" : undefined}
              aria-current={path === item.href ? "page" : undefined}
            >
              {t(item.labelKey)}
            </Link>
          ))}
          <button className="language-button" type="button" onClick={toggleLocale} aria-label={t("nav.language")}>
            <Globe2 size={17} />
            <span>{locale === "en" ? "ES" : "EN"}</span>
          </button>
        </nav>
      </header>

      <main>{children}</main>

      <footer className="site-footer">
        <div className="section-inner footer-grid">
          <div>
            <p className="footer-brand">{t("brand.title")}</p>
            <p>{t("footer.tagline")}</p>
          </div>
          <div className="footer-links">
            {navItems.map((item) => (
              <Link key={item.href} href={item.href}>
                {t(item.labelKey)}
              </Link>
            ))}
          </div>
          <p className="footer-legal">{t("footer.legal")}</p>
        </div>
      </footer>
    </div>
  );
}
